import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { MapContainer, TileLayer, ScaleControl, LayersControl, ZoomControl } from 'react-leaflet';
import { dictionary } from '../../lang';
import { MAP_LAYER } from '../../lib/constants';
/**
 * @param {import('geojson').Point} center
 * @param {number} zoom
 * @param {(layer: string) => void} onLayerChange
 * @param {import('react').ReactNode} children
 */
const LeafletMap = ({ center, zoom, onLayerChange, children, }) => {
    const { BaseLayer } = LayersControl;
    return (_jsxs(MapContainer, { className: "h-[800px]", center: { lat: center.coordinates[1], lng: center.coordinates[0] }, zoom: zoom, scrollWheelZoom: true, updateWhenIdle: false, zoomControl: false, doubleClickZoom: false, children: [_jsx(ScaleControl, {}), _jsx(ZoomControl, { position: "topright" }), _jsxs(LayersControl, { position: "bottomright", children: [_jsx(BaseLayer, { checked: true, name: dictionary.OPEN_STREET_MAP, children: _jsx(TileLayer, { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", attribution: '\u00A9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', eventHandlers: {
                                add: () => {
                                    onLayerChange(MAP_LAYER.OPEN_STREET_MAP);
                                },
                            } }) }), _jsx(BaseLayer, { name: dictionary.GOOGLE_MAPS, children: _jsx(TileLayer, { url: "https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}", attribution: "Imagery \u00A92022 TerraMetrics, Map data \u00A92022 Google, INEGI", maxZoom: 20, subdomains: ['mt0', 'mt1', 'mt2', 'mt3'], eventHandlers: {
                                add: () => {
                                    onLayerChange(MAP_LAYER.GOOGLE_MAPS);
                                },
                            } }) }), _jsx(BaseLayer, { name: dictionary.GOOGLE_HYBRID, children: _jsx(TileLayer, { url: "https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}", attribution: "Imagery \u00A92022 TerraMetrics, Map data \u00A92022 Google, INEGI", maxZoom: 20, subdomains: ['mt0', 'mt1', 'mt2', 'mt3'], eventHandlers: {
                                add: () => {
                                    onLayerChange(MAP_LAYER.GOOGLE_HYBRID);
                                },
                            } }) }), _jsx(BaseLayer, { name: dictionary.GOOGLE_SATELLITE, children: _jsx(TileLayer, { url: "https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}", attribution: "Imagery \u00A92022 TerraMetrics, Map data \u00A92022 Google, INEGI", maxZoom: 20, subdomains: ['mt1', 'mt2', 'mt3'], eventHandlers: {
                                add: () => {
                                    onLayerChange(MAP_LAYER.GOOGLE_SATELLITE);
                                },
                            } }) })] }), children] }));
};
LeafletMap.propTypes = {
    center: PropTypes.shape({
        type: PropTypes.oneOf(['Point']),
        coordinates: PropTypes.arrayOf(PropTypes.number),
    }),
    zoom: PropTypes.number,
    onLayerChange: PropTypes.func,
    children: PropTypes.node,
};
LeafletMap.defaultProps = {
    center: { type: 'Point', coordinates: [-111.9522, 40.6442] },
    zoom: 10,
    onLayerChange: () => { },
};
export default LeafletMap;
